import React, { useEffect } from 'react';
import { isNil } from 'lodash-es';
import { dateYearsAgo } from 'utils/generalUtils';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import OnboardingModalActions from '../../../OnboardingModalActions';

import gdprHealthIcon from './images/icon-gdpr-calendar.svg';

import styles from './AgeConfirmation.scss';
import HeaderIcon from '../../../HeaderIcon';
import {
  EXISTING_ATHLETE_FLOW,
  INPUT_IDS
} from '../../../../shared/onboardingConstants';
import DropdownDatePicker from '../../../../../../components/shared/DropdownDatePicker';
import {
  CLEAR_ALERT,
  UPDATE_CURRENT_ATHLETE
} from '../../../../state/Onboarding.actions';
import PERMISSION_TYPES from '../../../../../../constants/consents/permissionTypes';
import { YOUNGEST_AGE_FOR_HEALTH_AND_PROMO } from '../../../../../../constants/appConstants';

const Health = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { alert, locale, currentAthlete } = state;
  const { dob } = currentAthlete;
  useEffect(() => {
    track({
      page: analyticsPageName(EXISTING_ATHLETE_FLOW.ageConfirmation),
      action: 'screen_enter',
      properties: { dob }
    });
  }, [dob, track]);

  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  const handleDobChange = (date) => {
    dispatch({ type: CLEAR_ALERT });

    dispatch({
      type: UPDATE_CURRENT_ATHLETE,
      payload: { dob: date }
    });
  };

  const { year, month, day } = dob || {};

  const dobObject = (() => {
    if (!isNil(year) && !isNil(month) && !isNil(day)) {
      return new Date(year, month - 1, day); // jsDate starts with 0 for Jan
    }
    return null;
  })();

  const isInvalidBirthday =
    alert?.target === (INPUT_IDS.month || INPUT_IDS.day || INPUT_IDS.year);

  const dobErroredControls = (() => {
    return isInvalidBirthday ? alert.controls : [];
  })();

  const handleNextStep = () => {
    const isBefore16thBday =
      dobObject > dateYearsAgo(YOUNGEST_AGE_FOR_HEALTH_AND_PROMO);

    const action = isBefore16thBday ? ACTIONS.denied : ACTIONS.approved;

    stepForward({
      analyticsElement: 'continue',
      action,
      permissionType: PERMISSION_TYPES.ageConfirmation
    });
  };

  return (
    <>
      <ModalBodyWithAlerts alert={alert}>
        <HeaderIcon source={gdprHealthIcon} />
        <h2>{t('consents.age_confirmation.header')}</h2>
        <p>{t('consents.age_confirmation.description')}</p>

        <DropdownDatePicker
          className={styles.datepicker}
          dateChangeCallback={handleDobChange}
          erroredControls={dobErroredControls}
          locale={locale}
          required={true}
          focusTarget={alert?.target}
          dateSelected={dobObject}
        />
      </ModalBodyWithAlerts>
      <OnboardingModalActions>
        <ActionButton
          onClick={handleNextStep}
          data-cy="age-confirmation-next-step-btn"
          isProcessing={isProcessing}
          isDisabled={isProcessing}
          className={styles.actionButton}
        >
          {t('cta_actions.continue')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default Health;
